(function(){
 'use strict';
 const selector='.photo-color-card[data-card-product] .catalog-image-link img';
 const bindings=new WeakMap();
 function fit(w,h,iw,ih,bounds=[0,0,1,1]){
  const [left,top,bw,bh]=bounds,contain=Math.min(w/iw,h/ih),rw=iw*contain,rh=ih*contain;
  const scale=Math.min(8,w*.84/(rw*bw),h*.78/(rh*bh));
  return {scale,x:-(left+bw/2-.5)*rw*scale,y:-(top+bh/2-.5)*rh*scale,width:rw*bw*scale,height:rh*bh*scale};
 }
 function bind(img){
  const card=img.closest('.photo-color-card[data-card-product]');
  const product=(window.PS_CATALOG||[]).find(p=>p.id===card?.dataset.cardProduct);
  if(!product||product.productKind!=='headwear'||bindings.has(img))return;
  const frame=img.closest('.catalog-image-link');let disposed=false,generation=0;
  function apply(){
   if(disposed||!img.isConnected||!img.naturalWidth||!frame.clientWidth||!frame.clientHeight)return;
   const source=img.currentSrc||img.src,bounds=window.PS_PHOTO.bounds(source);
   if(!bounds)return;
   const g=fit(frame.clientWidth,frame.clientHeight,img.naturalWidth,img.naturalHeight,bounds);
   img.style.setProperty('--ps-card-photo-scale',String(g.scale));
   img.style.setProperty('--ps-card-photo-x',g.x+'px');img.style.setProperty('--ps-card-photo-y',g.y+'px');
   img.dataset.psCardFit='measured';
   if(img.srcset){const sizes=Math.ceil(img.naturalWidth*Math.min(frame.clientWidth/img.naturalWidth,frame.clientHeight/img.naturalHeight)*g.scale)+'px';if(img.sizes!==sizes)img.sizes=sizes;}
  }
  function measure(){
   const source=img.currentSrc||img.src,request=++generation;
   if(window.PS_PHOTO.bounds(source))apply();
   else{img.style.setProperty('--ps-card-photo-scale','1');img.style.setProperty('--ps-card-photo-x','0px');img.style.setProperty('--ps-card-photo-y','0px');img.dataset.psCardFit='pending';}
   window.PS_PHOTO.measure(source).then(()=>{if(!disposed&&generation===request&&(img.currentSrc||img.src)===source)apply();});
  }
  const resize=new ResizeObserver(apply);resize.observe(frame);img.addEventListener('load',measure);
  bindings.set(img,()=>{disposed=true;generation++;resize.disconnect();img.removeEventListener('load',measure);bindings.delete(img);});
  if(img.complete&&img.naturalWidth)measure();
 }
 function scan(node){if(node.nodeType!==1)return;if(node.matches(selector))bind(node);node.querySelectorAll(selector).forEach(bind);}
 function dispose(node){if(node.nodeType!==1)return;if(node.tagName==='IMG')bindings.get(node)?.();node.querySelectorAll('img').forEach(img=>bindings.get(img)?.());}
 const observer=new MutationObserver(records=>{for(const record of records){if(record.type==='attributes'){if(record.target.matches(selector))bind(record.target);continue;}record.removedNodes.forEach(dispose);record.addedNodes.forEach(scan);}});
 observer.observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['src']});
 scan(document.documentElement);
 window.PS_CARD_PHOTOS={fit};
})();
